var tempList = {
	accidentTypeList: [
		{
			id: 0,
			value: 2,
			label: "碰撞运动车辆",
		},
		{
			id: 1,
			value: 2,
			label: "碰撞静止车辆",
		},
		{
			id: 2,
			value: 2,
			label: "其他车辆间事故",
		},
		{
			id: 3,
			value: 1,
			label: "刮撞行人",
		},
		{
			id: 4,
			value: 1,
			label: "碾压行人",
		},
		{
			id: 5,
			value: 1,
			label: "碰撞后碾压行人",
		},
		{
			id: 6,
			value: 1,
			label: "其他车辆与人",
		},
		{
			id: 7,
			value: 3,
			label: "侧翻",
		},
		{
			id: 8,
			value: 3,
			label: "滚翻",
		},
		{
			id: 9,
			value: 3,
			label: "坠车",
		},
		{
			id: 10,
			value: 3,
			label: "失火",
		},
		{
			id: 11,
			value: 3,
			label: "撞固定物",
		},
		{
			id: 12,
			value: 3,
			label: "撞非固定物",
		},
		{
			id: 13,
			value: 3,
			label: "自身褶叠",
		},
		{
			id: 14,
			value: 3,
			label: "乘员跌落或抛出",
		},
		{
			id: 15,
			value: 3,
			label: "其他单车事故"
		},
	],
	flaList: [
		{
			CODE1: null,
			CODE: "01",
			id: 2001500,
			name: "大型汽车（黄底黑字）",
		},
		{
			CODE1: null,
			CODE: "02",
			id: 2001501,
			name: "小型汽车（蓝底白字）",
		},
		{
			CODE1: null,
			CODE: "03",
			id: 2001502,
			name: "使馆汽车",
		},
		{
			CODE1: null,
			CODE: "04",
			id: 2001503,
			name: "领馆汽车",
		},
		{
			CODE1: null,
			CODE: "05",
			id: 2001504,
			name: "境外汽车",
		},
		{
			CODE1: null,
			CODE: "06",
			id: 2001505,
			name: "外籍汽车 （黑底白字）",
		},
		{
			CODE1: null,
			CODE: "07",
			id: 2001506,
			name: "普通摩托车（黄底黑字）",
		},
		{
			CODE1: null,
			CODE: "08",
			id: 2001507,
			name: "轻便摩托车（蓝底白字）",
		},
		{
			CODE1: null,
			CODE: "09",
			id: 2001508,
			name: "使馆摩托车",
		},
		{
			CODE1: null,
			CODE: "10",
			id: 2001509,
			name: "领馆摩托车",
		},
		{
			CODE1: null,
			CODE: "11",
			id: 2001510,
			name: "境外摩托车",
		},
		{
			CODE1: null,
			CODE: "12",
			id: 2001511,
			name: "外籍摩托车",
		},
		{
			CODE1: null,
			CODE: "13",
			id: 2001512,
			name: "低速车",
		},
		{
			CODE1: null,
			CODE: "14",
			id: 2001513,
			name: "拖拉机",
		},
		{
			CODE1: null,
			CODE: "15",
			id: 2001514,
			name: "挂车（***挂）",
		},
		{
			CODE1: null,
			CODE: "16",
			id: 2001515,
			name: "教练汽车（***学）",
		},
		{
			CODE1: null,
			CODE: "17",
			id: 2001516,
			name: "教练摩托车",
		},
		{
			CODE1: null,
			CODE: "18",
			id: 2001517,
			name: "试验汽车",
		},
		{
			CODE1: null,
			CODE: "19",
			id: 2001518,
			name: "试验摩托车",
		},
		{
			CODE1: null,
			CODE: "20",
			id: 2001519,
			name: "临时入境汽车",
		},
		{
			CODE1: null,
			CODE: "21",
			id: 2001520,
			name: "临时入境摩托车",
		},
		{
			CODE1: null,
			CODE: "22",
			id: 2001521,
			name: "临时行驶车（临牌）",
		},
		{
			CODE1: null,
			CODE: "23",
			id: 2001522,
			name: "警用汽车（***警）",
		},
		{
			CODE1: null,
			CODE: "24",
			id: 2001523,
			name: "警用摩托",
		},
		{
			CODE1: null,
			CODE: "25",
			id: 2001524,
			name: "原农机号牌",
		},
		{
			CODE1: null,
			CODE: "26",
			id: 2001525,
			name: "香港入出境车",
		},
		{
			CODE1: null,
			CODE: "27",
			id: 2001526,
			name: "澳门入出境车",
		},
		{
			CODE1: null,
			CODE: "31",
			id: 2001527,
			name: "武警号牌",
		},
		{
			CODE1: null,
			CODE: "32",
			id: 2001528,
			name: "军队号牌",
		},
		{
			CODE1: null,
			CODE: "33",
			id: 2001529,
			name: "应急号牌",
		},
		{
			CODE1: null,
			CODE: "41",
			id: 2001530,
			name: "无号牌",
		},
		{
			CODE1: null,
			CODE: "42",
			id: 2001531,
			name: "假号牌",
		},
		{
			CODE1: null,
			CODE: "43",
			id: 2001532,
			name: "挪用号牌",
		},
		{
			CODE1: null,
			CODE: "51",
			id: 2001533,
			name: "大型新能源汽车",
		},
		{
			CODE1: null,
			CODE: "52",
			id: 2001534,
			name: "小型新能源汽车",
		},
		{
			CODE1: null,
			CODE: "99",
			id: 2001535,
			name: "其他号牌",
		},
		{
			CODE1: null,
			CODE: "B1",
			id: 2001536,
			name: "自行车号牌",
		},
		{
			CODE1: null,
			CODE: "C1",
			id: 2001537,
			name: "残疾人专用车号牌",
		},
		{
			CODE1: null,
			CODE: "D1",
			id: 2001538,
			name: "电动自行车正式号牌",
		},
		{
			CODE1: null,
			CODE: "D2",
			id: 2001539,
			name: "电动自行车临时号牌",
		},
		{
			CODE1: null,
			CODE: "D3",
			id: 2001540,
			name: "电动自行车其他号牌",
		},
		{
			CODE1: null,
			CODE: "Q1",
			id: 2001541,
			name: "其他非机动车号牌",
		},
		{
			CODE1: null,
			CODE: "S1",
			id: 2001542,
			name: "三轮车号牌",
		},
		{
			CODE1: null,
			CODE: "T1",
			id: 2001543,
			name: "手推车号牌",
		},
		{
			CODE1: null,
			CODE: "X1",
			id: 2001544,
			name: "畜力车号牌",
		},
		{
			CODE1: null,
			CODE: "Z1",
			id: 2001545,
			name: "助力自行车",
		},
	],
	vehList: [
		{
			CODE1: null,
			CODE: "K10",
			id: 2001045,
			name: "重型专项作业车",
		},
		{
			CODE1: null,
			CODE: "K11",
			id: 2000800,
			name: "大型普通客车",
		},
		{
			CODE1: null,
			CODE: "K12",
			id: 2000801,
			name: "大型双层客车",
		},
		{
			CODE1: null,
			CODE: "K13",
			id: 2000802,
			name: "大型卧铺客车",
		},
		{
			CODE1: null,
			CODE: "K14",
			id: 2000803,
			name: "大型铰接客车",
		},
		{
			CODE1: null,
			CODE: "K15",
			id: 2000804,
			name: "大型越野客车",
		},
		{
			CODE1: null,
			CODE: "K16",
			id: 2000805,
			name: "大型轿车",
		},
		{
			CODE1: null,
			CODE: "K17",
			id: 2000806,
			name: "大型专用客车",
		},
		{
			CODE1: null,
			CODE: "K18",
			id: 2000807,
			name: "大型专用校车",
		},
		{
			CODE1: null,
			CODE: "K21",
			id: 2000808,
			name: "中型普通客车",
		},
		{
			CODE1: null,
			CODE: "K22",
			id: 2000809,
			name: "中型双层客车",
		},
		{
			CODE1: null,
			CODE: "K23",
			id: 2000810,
			name: "中型卧铺客车",
		},
		{
			CODE1: null,
			CODE: "K24",
			id: 2000811,
			name: "中型铰接客车",
		},
		{
			CODE1: null,
			CODE: "K25",
			id: 2000812,
			name: "中型越野客车",
		},
		{
			CODE1: null,
			CODE: "K26",
			id: 2000813,
			name: "中型轿车",
		},
		{
			CODE1: null,
			CODE: "K27",
			id: 2000814,
			name: "中型专用客车",
		},
		{
			CODE1: null,
			CODE: "K28",
			id: 2000815,
			name: "中型专用校车",
		},
		{
			CODE1: null,
			CODE: "K31",
			id: 2000816,
			name: "小型普通客车",
		},
		{
			CODE1: null,
			CODE: "K32",
			id: 2000817,
			name: "小型越野客车",
		},
		{
			CODE1: null,
			CODE: "K33",
			id: 2000818,
			name: "小型轿车",
		},
		{
			CODE1: null,
			CODE: "K34",
			id: 2000819,
			name: "小型专用客车",
		},
		{
			CODE1: null,
			CODE: "K38",
			id: 2000820,
			name: "小型专用校车",
		},
		{
			CODE1: null,
			CODE: "K39",
			id: 2000821,
			name: "小型面包车",
		},
		{
			CODE1: null,
			CODE: "K41",
			id: 2000822,
			name: "微型普通客车",
		},
		{
			CODE1: null,
			CODE: "K42",
			id: 2000823,
			name: "微型越野客车",
		},
		{
			CODE1: null,
			CODE: "K43",
			id: 2000824,
			name: "微型轿车",
		},
		{
			CODE1: null,
			CODE: "K49",
			id: 2000825,
			name: "微型面包车",
		},
		{
			CODE1: null,
			CODE: "M11",
			id: 2000826,
			name: "正三轮摩托车",
		},
		{
			CODE1: null,
			CODE: "M12",
			id: 2000827,
			name: "轻便正三轮摩托车",
		},
		{
			CODE1: null,
			CODE: "M13",
			id: 2000828,
			name: "正三轮载客摩托车",
		},
		{
			CODE1: null,
			CODE: "M14",
			id: 2000829,
			name: "正三轮载货摩托车",
		},
		{
			CODE1: null,
			CODE: "M15",
			id: 2000830,
			name: "侧三轮摩托车",
		},
		{
			CODE1: null,
			CODE: "M21",
			id: 2000831,
			name: "普通二轮摩托车",
		},
		{
			CODE1: null,
			CODE: "M22",
			id: 2000832,
			name: "轻便二轮摩托车",
		},
		{
			CODE1: null,
			CODE: "A01",
			id: 2000833,
			name: "步行",
		},
		{
			CODE1: null,
			CODE: "B11",
			id: 2000834,
			name: "重型普通半挂车",
		},
		{
			CODE1: null,
			CODE: "B12",
			id: 2000835,
			name: "重型厢式半挂车",
		},
		{
			CODE1: null,
			CODE: "B13",
			id: 2000836,
			name: "重型罐式半挂车",
		},
		{
			CODE1: null,
			CODE: "B14",
			id: 2000837,
			name: "重型平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B15",
			id: 2000838,
			name: "重型集装箱半挂车",
		},
		{
			CODE1: null,
			CODE: "B16",
			id: 2000839,
			name: "重型自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B17",
			id: 2000840,
			name: "重型特殊结构半挂车",
		},
		{
			CODE1: null,
			CODE: "B18",
			id: 2000841,
			name: "重型仓栅式半挂车",
		},
		{
			CODE1: null,
			CODE: "B19",
			id: 2000842,
			name: "重型旅居半挂车",
		},
		{
			CODE1: null,
			CODE: "B1A",
			id: 2000843,
			name: "重型专项作业半挂车",
		},
		{
			CODE1: null,
			CODE: "B1B",
			id: 2000844,
			name: "重型低平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B1C",
			id: 2000845,
			name: "重型车辆运输半挂车",
		},
		{
			CODE1: null,
			CODE: "B1D",
			id: 2000846,
			name: "重型罐式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1E",
			id: 2000847,
			name: "重型平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1F",
			id: 2000848,
			name: "重型集装箱自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1G",
			id: 2000849,
			name: "重型特殊结构自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1H",
			id: 2000850,
			name: "重型仓栅式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1J",
			id: 2000851,
			name: "重型专项作业自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1K",
			id: 2000852,
			name: "重型低平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B1U",
			id: 2000853,
			name: "重型中置轴旅居挂车",
		},
		{
			CODE1: null,
			CODE: "B1V",
			id: 2000854,
			name: "重型中置轴车辆运输车",
		},
		{
			CODE1: null,
			CODE: "B1W",
			id: 2000855,
			name: "重型中置轴普通挂车",
		},
		{
			CODE1: null,
			CODE: "B21",
			id: 2000856,
			name: "中型普通半挂车",
		},
		{
			CODE1: null,
			CODE: "B22",
			id: 2000857,
			name: "中型厢式半挂车",
		},
		{
			CODE1: null,
			CODE: "B23",
			id: 2000858,
			name: "中型罐式半挂车",
		},
		{
			CODE1: null,
			CODE: "B24",
			id: 2000859,
			name: "中型平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B25",
			id: 2000860,
			name: "中型集装箱半挂车",
		},
		{
			CODE1: null,
			CODE: "B26",
			id: 2000861,
			name: "中型自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B27",
			id: 2000862,
			name: "中型特殊结构半挂车",
		},
		{
			CODE1: null,
			CODE: "B28",
			id: 2000863,
			name: "中型仓栅式半挂车",
		},
		{
			CODE1: null,
			CODE: "B29",
			id: 2000864,
			name: "中型旅居半挂车",
		},
		{
			CODE1: null,
			CODE: "B2A",
			id: 2000865,
			name: "中型专项作业半挂车",
		},
		{
			CODE1: null,
			CODE: "B2B",
			id: 2000866,
			name: "中型低平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B2C",
			id: 2000867,
			name: "中型车辆运输半挂车",
		},
		{
			CODE1: null,
			CODE: "B2D",
			id: 2000868,
			name: "中型罐式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2E",
			id: 2000869,
			name: "中型平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2F",
			id: 2000870,
			name: "中型集装箱自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2G",
			id: 2000871,
			name: "中型特殊结构自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2H",
			id: 2000872,
			name: "中型仓栅式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2J",
			id: 2000873,
			name: "中型专项作业自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2K",
			id: 2000874,
			name: "中型低平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B2U",
			id: 2000875,
			name: "中型中置轴旅居挂车",
		},
		{
			CODE1: null,
			CODE: "B2V",
			id: 2000876,
			name: "中型中置轴车辆运输车",
		},
		{
			CODE1: null,
			CODE: "B2W",
			id: 2000877,
			name: "中型中置轴普通挂车",
		},
		{
			CODE1: null,
			CODE: "B31",
			id: 2000878,
			name: "轻型普通半挂车",
		},
		{
			CODE1: null,
			CODE: "B32",
			id: 2000879,
			name: "轻型厢式半挂车",
		},
		{
			CODE1: null,
			CODE: "B33",
			id: 2000880,
			name: "轻型罐式半挂车",
		},
		{
			CODE1: null,
			CODE: "B34",
			id: 2000881,
			name: "轻型平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B35",
			id: 2000882,
			name: "轻型自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B36",
			id: 2000883,
			name: "轻型仓栅式半挂车",
		},
		{
			CODE1: null,
			CODE: "B37",
			id: 2000884,
			name: "轻型旅居半挂车",
		},
		{
			CODE1: null,
			CODE: "B38",
			id: 2000885,
			name: "轻型专项作业半挂车",
		},
		{
			CODE1: null,
			CODE: "B39",
			id: 2000886,
			name: "轻型低平板半挂车",
		},
		{
			CODE1: null,
			CODE: "B3C",
			id: 2000887,
			name: "轻型车辆运输半挂车",
		},
		{
			CODE1: null,
			CODE: "B3D",
			id: 2000888,
			name: "轻型罐式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3E",
			id: 2000889,
			name: "轻型平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3F",
			id: 2000890,
			name: "轻型集装箱自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3G",
			id: 2000891,
			name: "轻型特殊结构自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3H",
			id: 2000892,
			name: "轻型仓栅式自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3J",
			id: 2000893,
			name: "轻型专项作业自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3K",
			id: 2000894,
			name: "轻型低平板自卸半挂车",
		},
		{
			CODE1: null,
			CODE: "B3U",
			id: 2000895,
			name: "轻型中置轴旅居挂车",
		},
		{
			CODE1: null,
			CODE: "B3V",
			id: 2000896,
			name: "轻型中置轴车辆运输车",
		},
		{
			CODE1: null,
			CODE: "B3W",
			id: 2000897,
			name: "轻型中置轴普通挂车",
		},
		{
			CODE1: null,
			CODE: "C01",
			id: 2000898,
			name: "乘车",
		},
		{
			CODE1: null,
			CODE: "D11",
			id: 2000899,
			name: "无轨电车",
		},
		{
			CODE1: null,
			CODE: "D12",
			id: 2000900,
			name: "有轨电车",
		},
		{
			CODE1: null,
			CODE: "F01",
			id: 2000901,
			name: "自行车",
		},
		{
			CODE1: null,
			CODE: "F02",
			id: 2000902,
			name: "三轮车",
		},
		{
			CODE1: null,
			CODE: "F03",
			id: 2000903,
			name: "手推车",
		},
		{
			CODE1: null,
			CODE: "F04",
			id: 2000904,
			name: "残疾人专用车",
		},
		{
			CODE1: null,
			CODE: "F05",
			id: 2000905,
			name: "畜力车",
		},
		{
			CODE1: null,
			CODE: "F06",
			id: 2000906,
			name: "助力自行车",
		},
		{
			CODE1: null,
			CODE: "F07",
			id: 2000907,
			name: "电动自行车",
		},
		{
			CODE1: null,
			CODE: "F09",
			id: 2000908,
			name: "其他非机动车",
		},
		// {
		//     "CODE1": null,
		//     "CODE": "G11",
		//     "id": 2000909,
		//     "name": "重型普通全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G12",
		//     "id": 2000910,
		//     "name": "重型厢式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G13",
		//     "id": 2000911,
		//     "name": "重型罐式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G14",
		//     "id": 2000912,
		//     "name": "重型平板全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G15",
		//     "id": 2000913,
		//     "name": "重型集装箱全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G16",
		//     "id": 2000914,
		//     "name": "重型自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G17",
		//     "id": 2000915,
		//     "name": "重型仓栅式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G18",
		//     "id": 2000916,
		//     "name": "重型旅居全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G19",
		//     "id": 2000917,
		//     "name": "重型专项作业全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1A",
		//     "id": 2000918,
		//     "name": "重型厢式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1B",
		//     "id": 2000919,
		//     "name": "重型罐式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1C",
		//     "id": 2000920,
		//     "name": "重型平板自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1D",
		//     "id": 2000921,
		//     "name": "重型集装箱自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1E",
		//     "id": 2000922,
		//     "name": "重型仓栅式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G1F",
		//     "id": 2000923,
		//     "name": "重型专项作业自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G21",
		//     "id": 2000924,
		//     "name": "中型普通全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G22",
		//     "id": 2000925,
		//     "name": "中型厢式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G23",
		//     "id": 2000926,
		//     "name": "中型罐式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G24",
		//     "id": 2000927,
		//     "name": "中型平板全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G25",
		//     "id": 2000928,
		//     "name": "中型集装箱全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G26",
		//     "id": 2000929,
		//     "name": "中型自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G27",
		//     "id": 2000930,
		//     "name": "中型仓栅式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G28",
		//     "id": 2000931,
		//     "name": "中型旅居全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G29",
		//     "id": 2000932,
		//     "name": "中型专项作业全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2A",
		//     "id": 2000933,
		//     "name": "中型厢式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2B",
		//     "id": 2000934,
		//     "name": "中型罐式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2C",
		//     "id": 2000935,
		//     "name": "中型平板自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2D",
		//     "id": 2000936,
		//     "name": "中型集装箱自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2E",
		//     "id": 2000937,
		//     "name": "中型仓栅式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G2F",
		//     "id": 2000938,
		//     "name": "中型专项作业自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G31",
		//     "id": 2000939,
		//     "name": "轻型普通全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G32",
		//     "id": 2000940,
		//     "name": "轻型厢式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G33",
		//     "id": 2000941,
		//     "name": "轻型罐式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G34",
		//     "id": 2000942,
		//     "name": "轻型平板全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G35",
		//     "id": 2000943,
		//     "name": "轻型自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G36",
		//     "id": 2000944,
		//     "name": "轻型仓栅式全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G37",
		//     "id": 2000945,
		//     "name": "轻型旅居全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G38",
		//     "id": 2000946,
		//     "name": "轻型专项作业全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3A",
		//     "id": 2000947,
		//     "name": "轻型厢式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3B",
		//     "id": 2000948,
		//     "name": "轻型罐式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3C",
		//     "id": 2000949,
		//     "name": "轻型平板自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3D",
		//     "id": 2000950,
		//     "name": "轻型集装箱自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3E",
		//     "id": 2000951,
		//     "name": "轻型仓栅式自卸全挂车"
		// },
		// {
		//     "CODE1": null,
		//     "CODE": "G3F",
		//     "id": 2000952,
		//     "name": "轻型专项作业自卸全挂车"
		// },
		{
			CODE1: null,
			CODE: "H11",
			id: 2000953,
			name: "重型普通货车",
		},
		{
			CODE1: null,
			CODE: "H12",
			id: 2000954,
			name: "重型厢式货车",
		},
		{
			CODE1: null,
			CODE: "H13",
			id: 2000955,
			name: "重型封闭货车",
		},
		{
			CODE1: null,
			CODE: "H14",
			id: 2000956,
			name: "重型罐式货车",
		},
		{
			CODE1: null,
			CODE: "H15",
			id: 2000957,
			name: "重型平板货车",
		},
		{
			CODE1: null,
			CODE: "H16",
			id: 2000958,
			name: "重型集装厢车",
		},
		{
			CODE1: null,
			CODE: "H17",
			id: 2000959,
			name: "重型自卸货车",
		},
		{
			CODE1: null,
			CODE: "H18",
			id: 2000960,
			name: "重型特殊结构货车",
		},
		{
			CODE1: null,
			CODE: "H19",
			id: 2000961,
			name: "重型仓栅式货车",
		},
		{
			CODE1: null,
			CODE: "H1A",
			id: 2000962,
			name: "重型车辆运输车",
		},
		{
			CODE1: null,
			CODE: "H1B",
			id: 2000963,
			name: "重型厢式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H1C",
			id: 2000964,
			name: "重型罐式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H1D",
			id: 2000965,
			name: "重型平板自卸货车",
		},
		{
			CODE1: null,
			CODE: "H1E",
			id: 2000966,
			name: "重型集装厢自卸货车",
		},
		{
			CODE1: null,
			CODE: "H1F",
			id: 2000967,
			name: "重型特殊结构自卸货车",
		},
		{
			CODE1: null,
			CODE: "H1G",
			id: 2000968,
			name: "重型仓栅式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H21",
			id: 2000969,
			name: "中型普通货车",
		},
		{
			CODE1: null,
			CODE: "H22",
			id: 2000970,
			name: "中型厢式货车",
		},
		{
			CODE1: null,
			CODE: "H23",
			id: 2000971,
			name: "中型封闭货车",
		},
		{
			CODE1: null,
			CODE: "H24",
			id: 2000972,
			name: "中型罐式货车",
		},
		{
			CODE1: null,
			CODE: "H25",
			id: 2000973,
			name: "中型平板货车",
		},
		{
			CODE1: null,
			CODE: "H26",
			id: 2000974,
			name: "中型集装厢车",
		},
		{
			CODE1: null,
			CODE: "H27",
			id: 2000975,
			name: "中型自卸货车",
		},
		{
			CODE1: null,
			CODE: "H28",
			id: 2000976,
			name: "中型特殊结构货车",
		},
		{
			CODE1: null,
			CODE: "H29",
			id: 2000977,
			name: "中型仓栅式货车",
		},
		{
			CODE1: null,
			CODE: "H2A",
			id: 2000978,
			name: "中型车辆运输车",
		},
		{
			CODE1: null,
			CODE: "H2B",
			id: 2000979,
			name: "中型厢式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H2C",
			id: 2000980,
			name: "中型罐式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H2D",
			id: 2000981,
			name: "中型平板自卸货车",
		},
		{
			CODE1: null,
			CODE: "H2E",
			id: 2000982,
			name: "中型集装厢自卸货车",
		},
		{
			CODE1: null,
			CODE: "H2F",
			id: 2000983,
			name: "中型特殊结构自卸货车",
		},
		{
			CODE1: null,
			CODE: "H2G",
			id: 2000984,
			name: "中型仓栅式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H31",
			id: 2000985,
			name: "轻型普通货车",
		},
		{
			CODE1: null,
			CODE: "H32",
			id: 2000986,
			name: "轻型厢式货车",
		},
		{
			CODE1: null,
			CODE: "H33",
			id: 2000987,
			name: "轻型封闭货车",
		},
		{
			CODE1: null,
			CODE: "H34",
			id: 2000988,
			name: "轻型罐式货车",
		},
		{
			CODE1: null,
			CODE: "H35",
			id: 2000989,
			name: "轻型平板货车",
		},
		{
			CODE1: null,
			CODE: "H37",
			id: 2000990,
			name: "轻型自卸货车",
		},
		{
			CODE1: null,
			CODE: "H38",
			id: 2000991,
			name: "轻型特殊结构货车",
		},
		{
			CODE1: null,
			CODE: "H39",
			id: 2000992,
			name: "轻仓栅式货车",
		},
		{
			CODE1: null,
			CODE: "H3A",
			id: 2000993,
			name: "轻型车辆运输车",
		},
		{
			CODE1: null,
			CODE: "H3B",
			id: 2000994,
			name: "轻型厢式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H3C",
			id: 2000995,
			name: "轻型罐式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H3D",
			id: 2000996,
			name: "轻型平板自卸货车",
		},
		{
			CODE1: null,
			CODE: "H3F",
			id: 2000997,
			name: "轻型特殊结构自卸货车",
		},
		{
			CODE1: null,
			CODE: "H3G",
			id: 2000998,
			name: "轻型仓栅式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H41",
			id: 2000999,
			name: "微型普通货车",
		},
		{
			CODE1: null,
			CODE: "H42",
			id: 2001000,
			name: "微型厢式货车",
		},
		{
			CODE1: null,
			CODE: "H43",
			id: 2001001,
			name: "微型封闭货车",
		},
		{
			CODE1: null,
			CODE: "H44",
			id: 2001002,
			name: "微型罐式货车",
		},
		{
			CODE1: null,
			CODE: "H45",
			id: 2001003,
			name: "微型自卸货车",
		},
		{
			CODE1: null,
			CODE: "H46",
			id: 2001004,
			name: "微型特殊结构货车",
		},
		{
			CODE1: null,
			CODE: "H47",
			id: 2001005,
			name: "微型仓栅式货车",
		},
		{
			CODE1: null,
			CODE: "H4A",
			id: 2001006,
			name: "微型车辆运输车",
		},
		{
			CODE1: null,
			CODE: "H4B",
			id: 2001007,
			name: "微型厢式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H4C",
			id: 2001008,
			name: "微型罐式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H4F",
			id: 2001009,
			name: "微型特殊结构自卸货车",
		},
		{
			CODE1: null,
			CODE: "H4G",
			id: 2001010,
			name: "微型仓栅式自卸货车",
		},
		{
			CODE1: null,
			CODE: "H51",
			id: 2001011,
			name: "普通低速货车",
		},
		{
			CODE1: null,
			CODE: "H52",
			id: 2001012,
			name: "厢式低速货车",
		},
		{
			CODE1: null,
			CODE: "H53",
			id: 2001013,
			name: "罐式低速货车",
		},
		{
			CODE1: null,
			CODE: "H54",
			id: 2001014,
			name: "自卸低速货车",
		},
		{
			CODE1: null,
			CODE: "H55",
			id: 2001015,
			name: "仓栅式低速货车",
		},
		{
			CODE1: null,
			CODE: "H5B",
			id: 2001016,
			name: "厢式自卸低速货车",
		},
		{
			CODE1: null,
			CODE: "H5C",
			id: 2001017,
			name: "罐式自卸低速货车",
		},
		{
			CODE1: null,
			CODE: "J11",
			id: 2001018,
			name: "轮式装载机械",
		},
		{
			CODE1: null,
			CODE: "J12",
			id: 2001019,
			name: "轮式挖掘机械",
		},
		{
			CODE1: null,
			CODE: "J13",
			id: 2001020,
			name: "轮式平地机械",
		},
		{
			CODE1: null,
			CODE: "N11",
			id: 2001021,
			name: "三轮汽车",
		},
		{
			CODE1: null,
			CODE: "Q11",
			id: 2001022,
			name: "重型半挂牵引车",
		},
		{
			CODE1: null,
			CODE: "Q12",
			id: 2001023,
			name: "重型全挂牵引车",
		},
		{
			CODE1: null,
			CODE: "Q21",
			id: 2001024,
			name: "中型半挂牵引车",
		},
		{
			CODE1: null,
			CODE: "Q22",
			id: 2001025,
			name: "中型全挂牵引车",
		},
		{
			CODE1: null,
			CODE: "Q31",
			id: 2001026,
			name: "轻型半挂牵引车",
		},
		{
			CODE1: null,
			CODE: "Q32",
			id: 2001027,
			name: "轻型全挂牵引车",
		},
		{
			CODE1: null,
			CODE: "T11",
			id: 2001028,
			name: "大型轮式拖拉机",
		},
		{
			CODE1: null,
			CODE: "T21",
			id: 2001029,
			name: "小型轮式拖拉机",
		},
		{
			CODE1: null,
			CODE: "T22",
			id: 2001030,
			name: "手扶拖拉机",
		},
		{
			CODE1: null,
			CODE: "T23",
			id: 2001031,
			name: "手扶变形运输机",
		},
		{
			CODE1: null,
			CODE: "Z11",
			id: 2001032,
			name: "大型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z12",
			id: 2001033,
			name: "大型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z21",
			id: 2001034,
			name: "中型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z22",
			id: 2001035,
			name: "中型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z31",
			id: 2001036,
			name: "小型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z32",
			id: 2001037,
			name: "小型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z41",
			id: 2001038,
			name: "微型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z42",
			id: 2001039,
			name: "微型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z51",
			id: 2001040,
			name: "重型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z52",
			id: 2001041,
			name: "重型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z71",
			id: 2001042,
			name: "轻型非载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "Z72",
			id: 2001043,
			name: "轻型载货专项作业车",
		},
		{
			CODE1: null,
			CODE: "X99",
			id: 2001044,
			name: "其它",
		},
	],
	driList: [
		{
			CODE1: null,
			CODE: "A1",
			id: 2000600,
			name: "大型客车",
		},
		{
			CODE1: null,
			CODE: "A2",
			id: 2000601,
			name: "牵引车",
		},
		{
			CODE1: null,
			CODE: "A3",
			id: 2000602,
			name: "城市公交车",
		},
		{
			CODE1: null,
			CODE: "B1",
			id: 2000603,
			name: "中型客车",
		},
		{
			CODE1: null,
			CODE: "B2",
			id: 2000604,
			name: "大型货车",
		},
		{
			CODE1: null,
			CODE: "C1",
			id: 2000605,
			name: "小型汽车",
		},
		{
			CODE1: null,
			CODE: "C2",
			id: 2000606,
			name: "小型自动挡汽车",
		},
		{
			CODE1: null,
			CODE: "C3",
			id: 2000607,
			name: "低速载货汽车",
		},
		{
			CODE1: null,
			CODE: "C4",
			id: 2000608,
			name: "三轮汽车",
		},
		{
			CODE1: null,
			CODE: "C5",
			id: 2000609,
			name: "残疾人专用小型自动挡载客汽车",
		},
		{
			CODE1: null,
			CODE: "D",
			id: 2000610,
			name: "普通三轮摩托车",
		},
		{
			CODE1: null,
			CODE: "E",
			id: 2000611,
			name: "普通二轮摩托车",
		},
		{
			CODE1: null,
			CODE: "F",
			id: 2000612,
			name: "轻便摩托车",
		},
		{
			CODE1: null,
			CODE: "M",
			id: 2000613,
			name: "轮式自行机械车",
		},
		{
			CODE1: null,
			CODE: "N",
			id: 2000614,
			name: "无轨电车",
		},
		{
			CODE1: null,
			CODE: "P",
			id: 2000615,
			name: "有轨电车",
		},
	],
	indaList: [
		{
			CODE1: null,
			CODE: "1",
			id: 2000650,
			name: "前部",
		},
		{
			CODE1: null,
			CODE: "2",
			id: 2000651,
			name: "左前部",
		},
		{
			CODE1: null,
			CODE: "3",
			id: 2000652,
			name: "左侧",
		},
		{
			CODE1: null,
			CODE: "4",
			id: 2000653,
			name: "左后部",
		},
		{
			CODE1: null,
			CODE: "5",
			id: 2000654,
			name: "后部",
		},
		{
			CODE1: null,
			CODE: "6",
			id: 2000655,
			name: "右前部",
		},
		{
			CODE1: null,
			CODE: "7",
			id: 2000656,
			name: "右侧",
		},
		{
			CODE1: null,
			CODE: "8",
			id: 2000657,
			name: "右后部",
		},
	],
	accidList: [
		{
			CODE1: null,
			CODE: "1",
			id: 2000760,
			name: "全部责任",
		},
		{
			CODE1: null,
			CODE: "2",
			id: 2000761,
			name: "同等责任",
		},
		{
			CODE1: null,
			CODE: "3",
			id: 2000762,
			name: "无责任",
		},
	],
	accidentInfoTypeList: [
		{
			id: 1,
			name: "未避让正在作业的道路养护车辆、工程作业车",
		},
		{
			id: 2,
			name: "遇红灯时，右转弯车辆未让被放行的车辆先行",
		},
		{
			id: 3,
			name: "违法超车",
		},
		{
			id: 4,
			name: "载物超宽的部分碰撞其他车辆",
		},
		{
			id: 5,
			name: "碰撞依法暂停、停放的车辆",
		},
		{
			id: 6,
			name: "遇绿灯时，转弯车辆未让被放行直行车辆先行",
		},
		{
			id: 7,
			name: "相对方向行驶右转弯车未按规定让左转弯先行",
		},
		{
			id: 8,
			name: "转弯的车辆未按规定让直行车辆先行",
		},
		{
			id: 9,
			name: "优先通行交叉路口，未按规定让右方来车先行",
		},
		{
			id: 10,
			name: "未按规定让交通标志标线规定优先通行车先行",
		},
		{
			id: 11,
			name: "在交叉路口后被放行车未让先被放行车先行",
		},
		{
			id: 12,
			name: "进入环路口未让已在路口内机动车先行",
		},
		{
			id: 13,
			name: "借道进出停车场（位）妨碍其他车正常通行",
		},
		{
			id: 14,
			name: "进出或穿越道路，未按规定让行",
		},
		{
			id: 15,
			name: "在可以掉头地点掉头，未让正常行驶车辆先行",
		},
		{
			id: 16,
			name: "行经没有超车条件叉路口、窄桥、弯道等超车",
		},
		{
			id: 17,
			name: "与对面驶来的机动车有会车可能时超车的",
		},
		{
			id: 18,
			name: "超越前方正超车的机动车",
		},
		{
			id: 19,
			name: "在可掉头地点超越前方同车道正在掉头机动车",
		},
		{
			id: 20,
			name: "可左转弯地点超越前方同车道正左转弯机动车",
		},
		{
			id: 21,
			name: "靠山体一方未让不靠山体一方先行",
		},
		{
			id: 22,
			name: "上波车未让下坡车先行",
		},
		{
			id: 23,
			name: "下坡车未让上坡车先行",
		},
		{
			id: 24,
			name: "无障碍一方未让有障碍一方先行",
		},
		{
			id: 25,
			name: "有障碍一方未让无障碍一方先行",
		},
		{
			id: 26,
			name: "在变更车道时影响相关车道内正常行驶机动车",
		},
		{
			id: 27,
			name: "未避让执行紧急任务警车、消防车、救护车等",
		},
		{
			id: 28,
			name: "未按照交通警察指挥通行",
		},
		{
			id: 29,
			name: "驶入禁止通行道路",
		},
		{
			id: 30,
			name: "未按交通信号指示方向行驶",
		},
		{
			id: 31,
			name: "违反规定进入专用车道内行驶",
		},
		{
			id: 32,
			name: "在禁止掉头的地点掉头",
		},
		{
			id: 33,
			name: "遇红灯继续通行",
		},
		{
			id: 34,
			name: "违反规定开关车门",
		},
		{
			id: 35,
			name: "溜车",
		},
		{
			id: 36,
			name: "倒车",
		},
		{
			id: 37,
			name: "逆行",
		},
		{
			id: 38,
			name: "追尾",
		},
		{
			id: 39,
			name: "无",
		},
		{
			id: 40,
			name: "停车",
		},
		{
			id: 41,
			name: "停止状态的车辆",
		},
		{
			id: 42,
			name: "未按规定依次通行",
		},
		{
			id: 43,
			name: "未按规定让右方车辆先行",
		},
		{
			id: 44,
			name: "未确保安全",
		},
		{
			id: 45,
			name: "未按规定超车",
		},
		{
			id: 46,
			name: "未靠近中心点左侧转弯",
		},
		{
			id: 47,
			name: "直行",
		},
		{
			id: 48,
			name: "未确保安全",
		},
		{
			id: 49,
			name: "因车辆故障停在路上",
		},
		{
			id: 50,
			name: "未按规定车道行驶",
		},
		{
			id: 51,
			name: "违法停车",
		},
		{
			id: 52,
			name: "掉头时妨碍直行车辆正常通行",
		},
		{
			id: 53,
			name: "违反禁止标志红线",
		},
		{
			id: 54,
			name: "超长",
		},
	],
	identifydutyList: [
		{
			CODE1: null,
			CODE: "1",
			id: 2000750,
			name: "全部责任",
		},
		{
			CODE1: null,
			CODE: "2",
			id: 2000751,
			name: "主要责任",
		},
		{
			CODE1: null,
			CODE: "3",
			id: 2000752,
			name: "同等责任",
		},
		{
			CODE1: null,
			CODE: "4",
			id: 2000753,
			name: "次要责任",
		},
		{
			CODE1: null,
			CODE: "5",
			id: 2000754,
			name: "无责任",
		},
	],
	staList: [
		{
			CODE1: "",
			CODE: "99",
			id: 2000522,
			name: "其他",
		},
		{
			CODE1: null,
			CODE: "11",
			id: 2000500,
			name: "公务员",
		},
		{
			CODE1: null,
			CODE: "12",
			id: 2000501,
			name: "公安民警",
		},
		{
			CODE1: null,
			CODE: "13",
			id: 2000502,
			name: "职员",
		},
		{
			CODE1: null,
			CODE: "14",
			id: 2000503,
			name: "工人",
		},
		{
			CODE1: null,
			CODE: "15",
			id: 2000504,
			name: "农民",
		},
		{
			CODE1: null,
			CODE: "16",
			id: 2000505,
			name: "自主经营者",
		},
		{
			CODE1: null,
			CODE: "21",
			id: 2000506,
			name: "军人",
		},
		{
			CODE1: null,
			CODE: "22",
			id: 2000507,
			name: "武警",
		},
		{
			CODE1: null,
			CODE: "31",
			id: 2000508,
			name: "教师",
		},
		{
			CODE1: null,
			CODE: "32",
			id: 2000509,
			name: "大（专）学生",
		},
		{
			CODE1: null,
			CODE: "33",
			id: 2000510,
			name: "中（专）学生",
		},
		{
			CODE1: null,
			CODE: "34",
			id: 2000511,
			name: "小学生",
		},
		{
			CODE1: null,
			CODE: "35",
			id: 2000512,
			name: "学前儿童",
		},
		{
			CODE1: null,
			CODE: "41",
			id: 2000513,
			name: "港澳台胞",
		},
		{
			CODE1: null,
			CODE: "42",
			id: 2000514,
			name: "华侨",
		},
		{
			CODE1: null,
			CODE: "43",
			id: 2000515,
			name: "外国人",
		},
		{
			CODE1: null,
			CODE: "51",
			id: 2000516,
			name: "外来务工者",
		},
		{
			CODE1: null,
			CODE: "52",
			id: 2000517,
			name: "不在业人员",
		},
		{
			CODE1: null,
			CODE: "90",
			id: 2000518,
			name: "运输工人",
		},
		{
			CODE1: null,
			CODE: "91",
			id: 2000519,
			name: "环卫工人",
		},
		{
			CODE1: null,
			CODE: "92",
			id: 2000520,
			name: "商场营业员",
		},
		{
			CODE1: null,
			CODE: "94",
			id: 2000521,
			name: "离退休人员",
		},
	],
	drivingList: [
		{
			id: 100,
			name: "自定义",
		},
		{
			id: 1,
			name: "由南向北",
		},
		{
			id: 2,
			name: "由北向南",
		},
		{
			id: 3,
			name: "由西向东",
		},
		{
			id: 4,
			name: "由东向西",
		},
		{
			id: 5,
			name: "由东向西行驶时左转弯",
		},
		{
			id: 6,
			name: "由西向东行驶时左转弯",
		},
		{
			id: 7,
			name: "由南向北行驶时左转弯",
		},
		{
			id: 8,
			name: "由北向南行驶时左转弯",
		},
		{
			id: 9,
			name: "由北向南右转弯",
		},
		{
			id: 10,
			name: "由南向北右转弯",
		},
		{
			id: 11,
			name: "由东向西右转弯",
		},
		{
			id: 12,
			name: "由西向东右转弯",
		},
		{
			id: 13,
			name: "无",
		},
		{
			id: 14,
			name: "停放",
		},
		{
			id: 15,
			name: "停放路边",
		},
		{
			id: 16,
			name: "进入",
		},
		{
			id: 17,
			name: "超车",
		},
		{
			id: 18,
			name: "进站",
		},
		{
			id: 19,
			name: "由路边向机动车道内行驶",
		},
		{
			id: 20,
			name: "变更车道",
		},
		{
			id: 21,
			name: "小区门口出来",
		},
		{
			id: 22,
			name: "倒车",
		},
		{
			id: 23,
			name: "转弯",
		},
		{
			id: 24,
			name: "小区",
		},
		{
			id: 25,
			name: "直行",
		},
		{
			id: 26,
			name: "停车",
		},
		{
			id: 27,
			name: "在路边倒车",
		},
		{
			id: 28,
			name: "进入停车场",
		},
		{
			id: 29,
			name: "在停车场内倒车",
		},
		{
			id: 30,
			name: "停车等待通行",
		},
		{
			id: 31,
			name: "出车位",
		},
		{
			id: 32,
			name: "进入车位",
		},
		{
			id: 33,
			name: "掉头",
		},
		{
			id: 34,
			name: "调头",
		},
		{
			id: 35,
			name: "从人行道驶出",
		},
		{
			id: 36,
			name: "未按规定车道行驶",
		},
		{
			id: 37,
			name: "路边停车上人",
		},
		{
			id: 38,
			name: "出转盘右转弯",
		},
		{
			id: 39,
			name: "由非机动车道驶出",
		},
		{
			id: 40,
			name: "由机动车道驶入非机动车道",
		},
		{
			id: 41,
			name: "向下",
		},
		{
			id: 42,
			name: "出停车场",
		},
		{
			id: 43,
			name: "东向西掉头",
		},
		{
			id: 44,
			name: "西向东掉头",
		},
		{
			id: 45,
			name: "北向南掉头",
		},
		{
			id: 46,
			name: "南向北掉头",
		},
	],
	cerList: [
		{
			CODE1: null,
			CODE: "1",
			id: 2000000,
			name: "身份证",
		},
		{
			CODE1: null,
			CODE: "2",
			id: 2000001,
			name: "军官证",
		},
		{
			CODE1: null,
			CODE: "3",
			id: 2000002,
			name: "士兵证",
		},
		{
			CODE1: null,
			CODE: "4",
			id: 2000003,
			name: "警官证",
		},
		{
			CODE1: null,
			CODE: "5",
			id: 2000004,
			name: "港澳居民来往内地通行证",
		},
		{
			CODE1: null,
			CODE: "6",
			id: 2000005,
			name: "台湾居民来往大陆通行证",
		},
		{
			CODE1: null,
			CODE: "7",
			id: 2000006,
			name: "护照",
		},
		{
			CODE1: null,
			CODE: "8",
			id: 2000007,
			name: "其他",
		},
	],
	meaList: [
		{
			CODE1: "5",
			CODE: "N5",
			id: 2000594,
			name: "驾驶特种专项作业车",
		},
		{
			CODE1: "1",
			CODE: "K1",
			id: 2000550,
			name: "驾驶大型客车",
		},
		{
			CODE1: "1",
			CODE: "K2",
			id: 2000551,
			name: "驾驶中型客车",
		},
		{
			CODE1: "1",
			CODE: "K3",
			id: 2000552,
			name: "驾驶小型客车",
		},
		{
			CODE1: "1",
			CODE: "K4",
			id: 2000553,
			name: "驾驶微型客车",
		},
		{
			CODE1: "1",
			CODE: "H1",
			id: 2000554,
			name: "驾驶重型货车",
		},
		{
			CODE1: "1",
			CODE: "H2",
			id: 2000555,
			name: "驾驶中型货车",
		},
		{
			CODE1: "1",
			CODE: "H3",
			id: 2000556,
			name: "驾驶轻型货车",
		},
		{
			CODE1: "1",
			CODE: "H4",
			id: 2000557,
			name: "驾驶微型货车",
		},
		{
			CODE1: "1",
			CODE: "G1",
			id: 2000558,
			name: "驾驶汽车列车",
		},
		{
			CODE1: "1",
			CODE: "N1",
			id: 2000559,
			name: "驾驶三轮汽车",
		},
		{
			CODE1: "1",
			CODE: "N2",
			id: 2000560,
			name: "驾驶低速汽车",
		},
		{
			CODE1: "1",
			CODE: "Q1",
			id: 2000561,
			name: "驾驶其他汽车",
		},
		{
			CODE1: "1",
			CODE: "M1",
			id: 2000562,
			name: "驾驶普通摩托车",
		},
		{
			CODE1: "1",
			CODE: "M2",
			id: 2000563,
			name: "驾驶轻便摩托车",
		},
		{
			CODE1: "1",
			CODE: "T1",
			id: 2000564,
			name: "驾驶拖拉机",
		},
		{
			CODE1: "1",
			CODE: "J1",
			id: 2000565,
			name: "驾驶其他合法机动车",
		},
		{
			CODE1: "1",
			CODE: "J2",
			id: 2000566,
			name: "驾驶其他非法机动车",
		},
		{
			CODE1: "2",
			CODE: "N3",
			id: 2000567,
			name: "驾驶电动三轮车",
		},
		{
			CODE1: "2",
			CODE: "N4",
			id: 2000568,
			name: "驾驶四轮低速电动车",
		},
		{
			CODE1: "2",
			CODE: "F1",
			id: 2000569,
			name: "自行车",
		},
		{
			CODE1: "2",
			CODE: "F2",
			id: 2000570,
			name: "三轮车",
		},
		{
			CODE1: "2",
			CODE: "F3",
			id: 2000571,
			name: "手推车",
		},
		{
			CODE1: "2",
			CODE: "F4",
			id: 2000572,
			name: "残疾人专用车",
		},
		{
			CODE1: "2",
			CODE: "F5",
			id: 2000573,
			name: "畜力车",
		},
		{
			CODE1: "4",
			CODE: "F6",
			id: 2000574,
			name: "电动自行车",
		},
		{
			CODE1: "2",
			CODE: "F7",
			id: 2000575,
			name: "租赁自行车",
		},
		{
			CODE1: "2",
			CODE: "F8",
			id: 2000576,
			name: "共享单车",
		},
		{
			CODE1: "2",
			CODE: "F9",
			id: 2000577,
			name: "其它非机动车",
		},
		{
			CODE1: "2",
			CODE: "A1",
			id: 2000578,
			name: "步行",
		},
		{
			CODE1: "3",
			CODE: "C1",
			id: 2000579,
			name: "乘大中型汽车",
		},
		{
			CODE1: "3",
			CODE: "C2",
			id: 2000580,
			name: "乘小微型客车",
		},
		{
			CODE1: "3",
			CODE: "C3",
			id: 2000581,
			name: "乘普通货车",
		},
		{
			CODE1: "3",
			CODE: "C5",
			id: 2000582,
			name: "乘三轮汽车和低速货车",
		},
		{
			CODE1: "3",
			CODE: "C4",
			id: 2000583,
			name: "乘汽车列车",
		},
		{
			CODE1: "3",
			CODE: "C6",
			id: 2000584,
			name: "乘摩托车",
		},
		{
			CODE1: "3",
			CODE: "C7",
			id: 2000585,
			name: "乘拖拉机",
		},
		{
			CODE1: "3",
			CODE: "C8",
			id: 2000586,
			name: "乘三轮电动车",
		},
		{
			CODE1: "3",
			CODE: "C9",
			id: 2000587,
			name: "乘四轮低速电动车",
		},
		{
			CODE1: "3",
			CODE: "C21",
			id: 2000588,
			name: "乘自行车",
		},
		{
			CODE1: "3",
			CODE: "C23",
			id: 2000589,
			name: "乘电动自行车",
		},
		{
			CODE1: "3",
			CODE: "C22",
			id: 2000590,
			name: "乘三轮车",
		},
		{
			CODE1: "3",
			CODE: "C29",
			id: 2000591,
			name: "乘其他非机动车",
		},
		{
			CODE1: "3",
			CODE: "C19",
			id: 2000592,
			name: "乘其他机动车",
		},
		{
			CODE1: "3",
			CODE: "X9",
			id: 2000593,
			name: "其它",
		},
	],
	natList: [
		{
			CODE1: "",
			CODE: "051",
			id: 2000300,
			name: "中国",
		},
		{
			CODE1: null,
			CODE: "002",
			id: 2000251,
			name: "奥兰群岛",
		},
		{
			CODE1: null,
			CODE: "003",
			id: 2000252,
			name: "阿尔巴尼亚",
		},
		{
			CODE1: null,
			CODE: "004",
			id: 2000253,
			name: "阿尔及利亚",
		},
		{
			CODE1: null,
			CODE: "005",
			id: 2000254,
			name: "美属萨摩亚",
		},
		{
			CODE1: null,
			CODE: "006",
			id: 2000255,
			name: "安道尔",
		},
		{
			CODE1: null,
			CODE: "007",
			id: 2000256,
			name: "安哥拉",
		},
		{
			CODE1: null,
			CODE: "008",
			id: 2000257,
			name: "安圭拉",
		},
		{
			CODE1: null,
			CODE: "009",
			id: 2000258,
			name: "安提瓜和巴布达",
		},
		{
			CODE1: null,
			CODE: "010",
			id: 2000259,
			name: "阿根廷",
		},
		{
			CODE1: null,
			CODE: "011",
			id: 2000260,
			name: "亚美尼亚",
		},
		{
			CODE1: null,
			CODE: "012",
			id: 2000261,
			name: "阿鲁巴",
		},
		{
			CODE1: null,
			CODE: "013",
			id: 2000262,
			name: "澳大利亚",
		},
		{
			CODE1: null,
			CODE: "014",
			id: 2000263,
			name: "奥地利",
		},
		{
			CODE1: null,
			CODE: "015",
			id: 2000264,
			name: "阿塞拜疆",
		},
		{
			CODE1: null,
			CODE: "016",
			id: 2000265,
			name: "孟加拉",
		},
		{
			CODE1: null,
			CODE: "017",
			id: 2000266,
			name: "巴林",
		},
		{
			CODE1: null,
			CODE: "018",
			id: 2000267,
			name: "巴哈马",
		},
		{
			CODE1: null,
			CODE: "019",
			id: 2000268,
			name: "巴巴多斯",
		},
		{
			CODE1: null,
			CODE: "020",
			id: 2000269,
			name: "白俄罗斯",
		},
		{
			CODE1: null,
			CODE: "021",
			id: 2000270,
			name: "比利时",
		},
		{
			CODE1: null,
			CODE: "022",
			id: 2000271,
			name: "伯利兹",
		},
		{
			CODE1: null,
			CODE: "023",
			id: 2000272,
			name: "贝宁",
		},
		{
			CODE1: null,
			CODE: "024",
			id: 2000273,
			name: "百慕大",
		},
		{
			CODE1: null,
			CODE: "025",
			id: 2000274,
			name: "不丹",
		},
		{
			CODE1: null,
			CODE: "026",
			id: 2000275,
			name: "玻利维亚",
		},
		{
			CODE1: null,
			CODE: "027",
			id: 2000276,
			name: "波斯尼亚和黑塞哥维那",
		},
		{
			CODE1: null,
			CODE: "028",
			id: 2000277,
			name: "博茨瓦纳",
		},
		{
			CODE1: null,
			CODE: "029",
			id: 2000278,
			name: "布维岛",
		},
		{
			CODE1: null,
			CODE: "030",
			id: 2000279,
			name: "巴西",
		},
		{
			CODE1: null,
			CODE: "031",
			id: 2000280,
			name: "文莱",
		},
		{
			CODE1: null,
			CODE: "032",
			id: 2000281,
			name: "保加利亚",
		},
		{
			CODE1: null,
			CODE: "033",
			id: 2000282,
			name: "布基纳法索",
		},
		{
			CODE1: null,
			CODE: "034",
			id: 2000283,
			name: "布隆迪",
		},
		{
			CODE1: null,
			CODE: "035",
			id: 2000284,
			name: "柬埔寨",
		},
		{
			CODE1: null,
			CODE: "036",
			id: 2000285,
			name: "喀麦隆",
		},
		{
			CODE1: null,
			CODE: "037",
			id: 2000286,
			name: "加拿大",
		},
		{
			CODE1: null,
			CODE: "038",
			id: 2000287,
			name: "佛得角",
		},
		{
			CODE1: null,
			CODE: "039",
			id: 2000288,
			name: "中非",
		},
		{
			CODE1: null,
			CODE: "040",
			id: 2000289,
			name: "乍得",
		},
		{
			CODE1: null,
			CODE: "041",
			id: 2000290,
			name: "智利",
		},
		{
			CODE1: null,
			CODE: "042",
			id: 2000291,
			name: "圣诞岛",
		},
		{
			CODE1: null,
			CODE: "043",
			id: 2000292,
			name: "科科斯（基林）群岛",
		},
		{
			CODE1: null,
			CODE: "044",
			id: 2000293,
			name: "哥伦比亚",
		},
		{
			CODE1: null,
			CODE: "045",
			id: 2000294,
			name: "科摩罗",
		},
		{
			CODE1: null,
			CODE: "046",
			id: 2000295,
			name: "刚果（金）",
		},
		{
			CODE1: null,
			CODE: "047",
			id: 2000296,
			name: "刚果",
		},
		{
			CODE1: null,
			CODE: "048",
			id: 2000297,
			name: "库克群岛",
		},
		{
			CODE1: null,
			CODE: "049",
			id: 2000298,
			name: "哥斯达黎加",
		},
		{
			CODE1: null,
			CODE: "050",
			id: 2000299,
			name: "科特迪瓦",
		},
		{
			CODE1: "",
			CODE: "001",
			id: 2000250,
			name: "阿富汗",
		},
		{
			CODE1: null,
			CODE: "052",
			id: 2000301,
			name: "克罗地亚",
		},
		{
			CODE1: null,
			CODE: "053",
			id: 2000302,
			name: "古巴",
		},
		{
			CODE1: null,
			CODE: "054",
			id: 2000303,
			name: "捷克",
		},
		{
			CODE1: null,
			CODE: "055",
			id: 2000304,
			name: "塞浦路斯",
		},
		{
			CODE1: null,
			CODE: "056",
			id: 2000305,
			name: "丹麦",
		},
		{
			CODE1: null,
			CODE: "057",
			id: 2000306,
			name: "吉布提",
		},
		{
			CODE1: null,
			CODE: "058",
			id: 2000307,
			name: "多米尼加",
		},
		{
			CODE1: null,
			CODE: "059",
			id: 2000308,
			name: "东帝汶",
		},
		{
			CODE1: null,
			CODE: "060",
			id: 2000309,
			name: "厄瓜多尔",
		},
		{
			CODE1: null,
			CODE: "061",
			id: 2000310,
			name: "埃及",
		},
		{
			CODE1: null,
			CODE: "062",
			id: 2000311,
			name: "赤道几内亚",
		},
		{
			CODE1: null,
			CODE: "063",
			id: 2000312,
			name: "厄立特里亚",
		},
		{
			CODE1: null,
			CODE: "064",
			id: 2000313,
			name: "爱沙尼亚",
		},
		{
			CODE1: null,
			CODE: "065",
			id: 2000314,
			name: "埃塞俄比亚",
		},
		{
			CODE1: null,
			CODE: "066",
			id: 2000315,
			name: "法罗群岛",
		},
		{
			CODE1: null,
			CODE: "067",
			id: 2000316,
			name: "斐济",
		},
		{
			CODE1: null,
			CODE: "068",
			id: 2000317,
			name: "芬兰",
		},
		{
			CODE1: null,
			CODE: "069",
			id: 2000318,
			name: "法国",
		},
		{
			CODE1: null,
			CODE: "070",
			id: 2000319,
			name: "法国大都会",
		},
		{
			CODE1: null,
			CODE: "071",
			id: 2000320,
			name: "法属圭亚那",
		},
		{
			CODE1: null,
			CODE: "072",
			id: 2000321,
			name: "法属波利尼西亚",
		},
		{
			CODE1: null,
			CODE: "073",
			id: 2000322,
			name: "加蓬",
		},
		{
			CODE1: null,
			CODE: "074",
			id: 2000323,
			name: "冈比亚",
		},
		{
			CODE1: null,
			CODE: "075",
			id: 2000324,
			name: "格鲁吉亚",
		},
		{
			CODE1: null,
			CODE: "076",
			id: 2000325,
			name: "德国",
		},
		{
			CODE1: null,
			CODE: "077",
			id: 2000326,
			name: "加纳",
		},
		{
			CODE1: null,
			CODE: "078",
			id: 2000327,
			name: "直布罗陀",
		},
		{
			CODE1: null,
			CODE: "079",
			id: 2000328,
			name: "希腊",
		},
		{
			CODE1: null,
			CODE: "080",
			id: 2000329,
			name: "格林纳达",
		},
		{
			CODE1: null,
			CODE: "081",
			id: 2000330,
			name: "瓜德罗普岛",
		},
		{
			CODE1: null,
			CODE: "082",
			id: 2000331,
			name: "关岛",
		},
		{
			CODE1: null,
			CODE: "083",
			id: 2000332,
			name: "危地马拉",
		},
		{
			CODE1: null,
			CODE: "084",
			id: 2000333,
			name: "根西岛",
		},
		{
			CODE1: null,
			CODE: "085",
			id: 2000334,
			name: "几内亚比绍",
		},
		{
			CODE1: null,
			CODE: "086",
			id: 2000335,
			name: "几内亚",
		},
		{
			CODE1: null,
			CODE: "087",
			id: 2000336,
			name: "圭亚那",
		},
		{
			CODE1: null,
			CODE: "088",
			id: 2000337,
			name: "海地",
		},
		{
			CODE1: null,
			CODE: "089",
			id: 2000338,
			name: "洪都拉斯",
		},
		{
			CODE1: null,
			CODE: "090",
			id: 2000339,
			name: "匈牙利",
		},
		{
			CODE1: null,
			CODE: "091",
			id: 2000340,
			name: "冰岛",
		},
		{
			CODE1: null,
			CODE: "092",
			id: 2000341,
			name: "印度",
		},
		{
			CODE1: null,
			CODE: "093",
			id: 2000342,
			name: "印度尼西亚",
		},
		{
			CODE1: null,
			CODE: "094",
			id: 2000343,
			name: "伊朗",
		},
		{
			CODE1: null,
			CODE: "095",
			id: 2000344,
			name: "伊拉克",
		},
		{
			CODE1: null,
			CODE: "096",
			id: 2000345,
			name: "爱尔兰",
		},
		{
			CODE1: null,
			CODE: "097",
			id: 2000346,
			name: "马恩岛",
		},
		{
			CODE1: null,
			CODE: "098",
			id: 2000347,
			name: "以色列",
		},
		{
			CODE1: null,
			CODE: "099",
			id: 2000348,
			name: "意大利",
		},
		{
			CODE1: null,
			CODE: "100",
			id: 2000349,
			name: "牙买加",
		},
		{
			CODE1: null,
			CODE: "101",
			id: 2000350,
			name: "日本",
		},
		{
			CODE1: null,
			CODE: "102",
			id: 2000351,
			name: "泽西岛",
		},
		{
			CODE1: null,
			CODE: "103",
			id: 2000352,
			name: "约旦",
		},
		{
			CODE1: null,
			CODE: "104",
			id: 2000353,
			name: "哈萨克斯坦",
		},
		{
			CODE1: null,
			CODE: "105",
			id: 2000354,
			name: "肯尼亚",
		},
		{
			CODE1: null,
			CODE: "106",
			id: 2000355,
			name: "基里巴斯",
		},
		{
			CODE1: null,
			CODE: "107",
			id: 2000356,
			name: "韩国",
		},
		{
			CODE1: null,
			CODE: "108",
			id: 2000357,
			name: "朝鲜",
		},
		{
			CODE1: null,
			CODE: "109",
			id: 2000358,
			name: "科威特",
		},
		{
			CODE1: null,
			CODE: "110",
			id: 2000359,
			name: "吉尔吉斯斯坦",
		},
		{
			CODE1: null,
			CODE: "111",
			id: 2000360,
			name: "老挝",
		},
		{
			CODE1: null,
			CODE: "112",
			id: 2000361,
			name: "拉脱维亚",
		},
		{
			CODE1: null,
			CODE: "113",
			id: 2000362,
			name: "黎巴嫩",
		},
		{
			CODE1: null,
			CODE: "114",
			id: 2000363,
			name: "莱索托",
		},
		{
			CODE1: null,
			CODE: "115",
			id: 2000364,
			name: "利比里亚",
		},
		{
			CODE1: null,
			CODE: "116",
			id: 2000365,
			name: "利比亚",
		},
		{
			CODE1: null,
			CODE: "117",
			id: 2000366,
			name: "列支敦士登",
		},
		{
			CODE1: null,
			CODE: "118",
			id: 2000367,
			name: "立陶宛",
		},
		{
			CODE1: null,
			CODE: "119",
			id: 2000368,
			name: "卢森堡",
		},
		{
			CODE1: null,
			CODE: "120",
			id: 2000369,
			name: "马其顿",
		},
		{
			CODE1: null,
			CODE: "121",
			id: 2000370,
			name: "马拉维",
		},
		{
			CODE1: null,
			CODE: "122",
			id: 2000371,
			name: "马来西亚",
		},
		{
			CODE1: null,
			CODE: "123",
			id: 2000372,
			name: "马达加斯加",
		},
		{
			CODE1: null,
			CODE: "124",
			id: 2000373,
			name: "马尔代夫",
		},
		{
			CODE1: null,
			CODE: "125",
			id: 2000374,
			name: "马里",
		},
		{
			CODE1: null,
			CODE: "126",
			id: 2000375,
			name: "马耳他",
		},
		{
			CODE1: null,
			CODE: "127",
			id: 2000376,
			name: "马绍尔群岛",
		},
		{
			CODE1: null,
			CODE: "128",
			id: 2000377,
			name: "马提尼克岛",
		},
		{
			CODE1: null,
			CODE: "129",
			id: 2000378,
			name: "毛里塔尼亚",
		},
		{
			CODE1: null,
			CODE: "130",
			id: 2000379,
			name: "毛里求斯",
		},
		{
			CODE1: null,
			CODE: "131",
			id: 2000380,
			name: "马约特",
		},
		{
			CODE1: null,
			CODE: "132",
			id: 2000381,
			name: "墨西哥",
		},
		{
			CODE1: null,
			CODE: "133",
			id: 2000382,
			name: "密克罗尼西亚",
		},
		{
			CODE1: null,
			CODE: "134",
			id: 2000383,
			name: "摩尔多瓦",
		},
		{
			CODE1: null,
			CODE: "135",
			id: 2000384,
			name: "摩纳哥",
		},
		{
			CODE1: null,
			CODE: "136",
			id: 2000385,
			name: "蒙古",
		},
		{
			CODE1: null,
			CODE: "137",
			id: 2000386,
			name: "黑山",
		},
		{
			CODE1: null,
			CODE: "138",
			id: 2000387,
			name: "蒙特塞拉特",
		},
		{
			CODE1: null,
			CODE: "139",
			id: 2000388,
			name: "摩洛哥",
		},
		{
			CODE1: null,
			CODE: "140",
			id: 2000389,
			name: "莫桑比克",
		},
		{
			CODE1: null,
			CODE: "141",
			id: 2000390,
			name: "缅甸",
		},
		{
			CODE1: null,
			CODE: "142",
			id: 2000391,
			name: "纳米比亚",
		},
		{
			CODE1: null,
			CODE: "143",
			id: 2000392,
			name: "瑙鲁",
		},
		{
			CODE1: null,
			CODE: "144",
			id: 2000393,
			name: "尼泊尔",
		},
		{
			CODE1: null,
			CODE: "145",
			id: 2000394,
			name: "荷兰",
		},
		{
			CODE1: null,
			CODE: "146",
			id: 2000395,
			name: "新喀里多尼亚",
		},
		{
			CODE1: null,
			CODE: "147",
			id: 2000396,
			name: "新西兰",
		},
		{
			CODE1: null,
			CODE: "148",
			id: 2000397,
			name: "尼加拉瓜",
		},
		{
			CODE1: null,
			CODE: "149",
			id: 2000398,
			name: "尼日尔",
		},
		{
			CODE1: null,
			CODE: "150",
			id: 2000399,
			name: "尼日利亚",
		},
		{
			CODE1: null,
			CODE: "151",
			id: 2000400,
			name: "纽埃",
		},
		{
			CODE1: null,
			CODE: "152",
			id: 2000401,
			name: "诺福克岛",
		},
		{
			CODE1: null,
			CODE: "153",
			id: 2000402,
			name: "挪威",
		},
		{
			CODE1: null,
			CODE: "154",
			id: 2000403,
			name: "阿曼",
		},
		{
			CODE1: null,
			CODE: "155",
			id: 2000404,
			name: "巴基斯坦",
		},
		{
			CODE1: null,
			CODE: "156",
			id: 2000405,
			name: "帕劳",
		},
		{
			CODE1: null,
			CODE: "157",
			id: 2000406,
			name: "巴勒斯坦",
		},
		{
			CODE1: null,
			CODE: "158",
			id: 2000407,
			name: "巴拿马",
		},
		{
			CODE1: null,
			CODE: "159",
			id: 2000408,
			name: "巴布亚新几内亚",
		},
		{
			CODE1: null,
			CODE: "160",
			id: 2000409,
			name: "秘鲁",
		},
		{
			CODE1: null,
			CODE: "161",
			id: 2000410,
			name: "菲律宾",
		},
		{
			CODE1: null,
			CODE: "162",
			id: 2000411,
			name: "皮特凯恩群岛",
		},
		{
			CODE1: null,
			CODE: "163",
			id: 2000412,
			name: "波兰",
		},
		{
			CODE1: null,
			CODE: "164",
			id: 2000413,
			name: "葡萄牙",
		},
		{
			CODE1: null,
			CODE: "165",
			id: 2000414,
			name: "波多黎各",
		},
		{
			CODE1: null,
			CODE: "166",
			id: 2000415,
			name: "卡塔尔",
		},
		{
			CODE1: null,
			CODE: "167",
			id: 2000416,
			name: "留尼汪岛",
		},
		{
			CODE1: null,
			CODE: "168",
			id: 2000417,
			name: "罗马尼亚",
		},
		{
			CODE1: null,
			CODE: "169",
			id: 2000418,
			name: "卢旺达",
		},
		{
			CODE1: null,
			CODE: "170",
			id: 2000419,
			name: "俄罗斯联邦",
		},
		{
			CODE1: null,
			CODE: "171",
			id: 2000420,
			name: "圣赫勒拿",
		},
		{
			CODE1: null,
			CODE: "172",
			id: 2000421,
			name: "圣基茨和尼维斯",
		},
		{
			CODE1: null,
			CODE: "173",
			id: 2000422,
			name: "圣卢西亚",
		},
		{
			CODE1: null,
			CODE: "174",
			id: 2000423,
			name: "圣文森特和格林纳丁斯",
		},
		{
			CODE1: null,
			CODE: "175",
			id: 2000424,
			name: "萨尔瓦多",
		},
		{
			CODE1: null,
			CODE: "176",
			id: 2000425,
			name: "萨摩亚",
		},
		{
			CODE1: null,
			CODE: "177",
			id: 2000426,
			name: "圣马力诺",
		},
		{
			CODE1: null,
			CODE: "178",
			id: 2000427,
			name: "圣多美和普林西比",
		},
		{
			CODE1: null,
			CODE: "179",
			id: 2000428,
			name: "沙特阿拉伯",
		},
		{
			CODE1: null,
			CODE: "180",
			id: 2000429,
			name: "塞内加尔",
		},
		{
			CODE1: null,
			CODE: "181",
			id: 2000430,
			name: "塞舌尔",
		},
		{
			CODE1: null,
			CODE: "182",
			id: 2000431,
			name: "塞拉利昂",
		},
		{
			CODE1: null,
			CODE: "183",
			id: 2000432,
			name: "新加坡",
		},
		{
			CODE1: null,
			CODE: "184",
			id: 2000433,
			name: "塞尔维亚",
		},
		{
			CODE1: null,
			CODE: "185",
			id: 2000434,
			name: "斯洛伐克",
		},
		{
			CODE1: null,
			CODE: "186",
			id: 2000435,
			name: "斯洛文尼亚",
		},
		{
			CODE1: null,
			CODE: "187",
			id: 2000436,
			name: "所罗门群岛",
		},
		{
			CODE1: null,
			CODE: "188",
			id: 2000437,
			name: "索马里",
		},
		{
			CODE1: null,
			CODE: "189",
			id: 2000438,
			name: "南非",
		},
		{
			CODE1: null,
			CODE: "190",
			id: 2000439,
			name: "西班牙",
		},
		{
			CODE1: null,
			CODE: "191",
			id: 2000440,
			name: "斯里兰卡",
		},
		{
			CODE1: null,
			CODE: "192",
			id: 2000441,
			name: "苏丹",
		},
		{
			CODE1: null,
			CODE: "193",
			id: 2000442,
			name: "苏里南",
		},
		{
			CODE1: null,
			CODE: "194",
			id: 2000443,
			name: "斯威士兰",
		},
		{
			CODE1: null,
			CODE: "195",
			id: 2000444,
			name: "瑞典",
		},
		{
			CODE1: null,
			CODE: "196",
			id: 2000445,
			name: "瑞士",
		},
		{
			CODE1: null,
			CODE: "197",
			id: 2000446,
			name: "叙利亚",
		},
		{
			CODE1: null,
			CODE: "198",
			id: 2000447,
			name: "塔吉克斯坦",
		},
		{
			CODE1: null,
			CODE: "199",
			id: 2000448,
			name: "坦桑尼亚",
		},
		{
			CODE1: null,
			CODE: "200",
			id: 2000449,
			name: "泰国",
		},
		{
			CODE1: null,
			CODE: "201",
			id: 2000450,
			name: "特立尼达和多巴哥",
		},
		{
			CODE1: null,
			CODE: "202",
			id: 2000451,
			name: "东帝汶",
		},
		{
			CODE1: null,
			CODE: "203",
			id: 2000452,
			name: "多哥",
		},
		{
			CODE1: null,
			CODE: "204",
			id: 2000453,
			name: "托克劳",
		},
		{
			CODE1: null,
			CODE: "205",
			id: 2000454,
			name: "汤加",
		},
		{
			CODE1: null,
			CODE: "206",
			id: 2000455,
			name: "突尼斯",
		},
		{
			CODE1: null,
			CODE: "207",
			id: 2000456,
			name: "土耳其",
		},
		{
			CODE1: null,
			CODE: "208",
			id: 2000457,
			name: "土库曼斯坦",
		},
		{
			CODE1: null,
			CODE: "209",
			id: 2000458,
			name: "图瓦卢",
		},
		{
			CODE1: null,
			CODE: "210",
			id: 2000459,
			name: "乌干达",
		},
		{
			CODE1: null,
			CODE: "211",
			id: 2000460,
			name: "乌克兰",
		},
		{
			CODE1: null,
			CODE: "212",
			id: 2000461,
			name: "阿拉伯联合酋长国",
		},
		{
			CODE1: null,
			CODE: "213",
			id: 2000462,
			name: "英国",
		},
		{
			CODE1: null,
			CODE: "214",
			id: 2000463,
			name: "美国",
		},
		{
			CODE1: null,
			CODE: "215",
			id: 2000464,
			name: "乌拉圭",
		},
		{
			CODE1: null,
			CODE: "216",
			id: 2000465,
			name: "乌兹别克斯坦",
		},
		{
			CODE1: null,
			CODE: "217",
			id: 2000466,
			name: "瓦努阿图",
		},
		{
			CODE1: null,
			CODE: "218",
			id: 2000467,
			name: "梵蒂冈",
		},
		{
			CODE1: null,
			CODE: "219",
			id: 2000468,
			name: "委内瑞拉",
		},
		{
			CODE1: null,
			CODE: "220",
			id: 2000469,
			name: "越南",
		},
		{
			CODE1: null,
			CODE: "221",
			id: 2000470,
			name: "瓦利斯群岛和富图纳群岛",
		},
		{
			CODE1: null,
			CODE: "222",
			id: 2000471,
			name: "西撒哈拉",
		},
		{
			CODE1: null,
			CODE: "223",
			id: 2000472,
			name: "也门",
		},
		{
			CODE1: null,
			CODE: "224",
			id: 2000473,
			name: "南斯拉夫",
		},
		{
			CODE1: null,
			CODE: "225",
			id: 2000474,
			name: "赞比亚",
		},
		{
			CODE1: null,
			CODE: "226",
			id: 2000475,
			name: "津巴布韦",
		},
	],
	caList: [
		{
			CODE1: null,
			CODE: "1",
			id: 2000150,
			name: "非机动车",
		},
		{
			CODE1: null,
			CODE: "2",
			id: 2000151,
			name: "无牌无证机动车",
		},
		{
			CODE1: null,
			CODE: "3",
			id: 2000152,
			name: "公安牌证机动车",
		},
		{
			CODE1: null,
			CODE: "4",
			id: 2000153,
			name: "武警牌证机动车",
		},
		{
			CODE1: null,
			CODE: "5",
			id: 2000154,
			name: "部队牌证机动车",
		},
		{
			CODE1: null,
			CODE: "6",
			id: 2000155,
			name: "农机牌证机动车",
		},
		{
			CODE1: null,
			CODE: "9",
			id: 2000156,
			name: "其他",
		},
	],
	vehmoList: [
		{
			CODE1: null,
			CODE: "A",
			id: 2000100,
			name: "白",
		},
		{
			CODE1: null,
			CODE: "B",
			id: 2000101,
			name: "灰",
		},
		{
			CODE1: null,
			CODE: "C",
			id: 2000102,
			name: "黄",
		},
		{
			CODE1: null,
			CODE: "D",
			id: 2000103,
			name: "粉",
		},
		{
			CODE1: null,
			CODE: "E",
			id: 2000104,
			name: "红",
		},
		{
			CODE1: null,
			CODE: "F",
			id: 2000105,
			name: "紫",
		},
		{
			CODE1: null,
			CODE: "G",
			id: 2000106,
			name: "绿",
		},
		{
			CODE1: null,
			CODE: "H",
			id: 2000107,
			name: "蓝",
		},
		{
			CODE1: null,
			CODE: "I",
			id: 2000108,
			name: "棕",
		},
		{
			CODE1: null,
			CODE: "J",
			id: 2000109,
			name: "黑",
		},
	],
	marnatList: [
		{
			CODE1: null,
			CODE: "A",
			id: 2000050,
			name: "非营运",
		},
		{
			CODE1: null,
			CODE: "B",
			id: 2000051,
			name: "公路客运",
		},
		{
			CODE1: null,
			CODE: "C",
			id: 2000052,
			name: "公交客运",
		},
		{
			CODE1: null,
			CODE: "D",
			id: 2000053,
			name: "出租客运",
		},
		{
			CODE1: null,
			CODE: "E",
			id: 2000054,
			name: "旅游客运",
		},
		{
			CODE1: null,
			CODE: "F",
			id: 2000055,
			name: "货运",
		},
		{
			CODE1: null,
			CODE: "G",
			id: 2000056,
			name: "租赁",
		},
		{
			CODE1: null,
			CODE: "H",
			id: 2000057,
			name: "警用",
		},
		{
			CODE1: null,
			CODE: "I",
			id: 2000058,
			name: "消防",
		},
		{
			CODE1: null,
			CODE: "J",
			id: 2000059,
			name: "救护",
		},
		{
			CODE1: null,
			CODE: "K",
			id: 2000060,
			name: "工程抢险车",
		},
		{
			CODE1: null,
			CODE: "L",
			id: 2000061,
			name: "营转非",
		},
		{
			CODE1: null,
			CODE: "M",
			id: 2000062,
			name: "出租转非",
		},
		{
			CODE1: null,
			CODE: "N",
			id: 2000063,
			name: "教练",
		},
		{
			CODE1: null,
			CODE: "O",
			id: 2000064,
			name: "幼儿校车",
		},
		{
			CODE1: null,
			CODE: "P",
			id: 2000065,
			name: "小学生校车",
		},
		{
			CODE1: null,
			CODE: "Q",
			id: 2000066,
			name: "其他校车",
		},
		{
			CODE1: null,
			CODE: "R",
			id: 2000067,
			name: "危化品运输",
		},
		{
			CODE1: null,
			CODE: "S",
			id: 2000068,
			name: "中小学生校车",
		},
		{
			CODE1: null,
			CODE: "T",
			id: 2000069,
			name: "预约出租客运",
		},
		{
			CODE1: null,
			CODE: "U",
			id: 2000070,
			name: "预约出租转非",
		},
	],
	liceList: [
		{
			CODE1: "",
			CODE: "5",
			id: 2000214,
			name: "辽",
		},
		{
			CODE1: "",
			CODE: "36",
			id: 2003153,
			name: "辽临",
		},
		{
			CODE1: "",
			CODE: "1",
			id: 2000210,
			name: "京",
		},
		{
			CODE1: "",
			CODE: "35",
			id: 2003152,
			name: "北京",
		},
		{
			CODE1: "",
			CODE: "2",
			id: 2000211,
			name: "津",
		},
		{
			CODE1: "",
			CODE: "3",
			id: 2000212,
			name: "冀",
		},
		{
			CODE1: "",
			CODE: "4",
			id: 2000213,
			name: "蒙",
		},
		{
			CODE1: "",
			CODE: "6",
			id: 2000215,
			name: "鲁",
		},
		{
			CODE1: "",
			CODE: "7",
			id: 2000216,
			name: "晋",
		},
		{
			CODE1: "",
			CODE: "8",
			id: 2000217,
			name: "渝",
		},
		{
			CODE1: "",
			CODE: "9",
			id: 2000218,
			name: "沪",
		},
		{
			CODE1: "",
			CODE: "10",
			id: 2000219,
			name: "吉",
		},
		{
			CODE1: "",
			CODE: "11",
			id: 2000220,
			name: "黑",
		},
		{
			CODE1: "",
			CODE: "12",
			id: 2000221,
			name: "苏",
		},
		{
			CODE1: "",
			CODE: "13",
			id: 2000222,
			name: "浙",
		},
		{
			CODE1: "",
			CODE: "14",
			id: 2000223,
			name: "皖",
		},
		{
			CODE1: "",
			CODE: "15",
			id: 2000224,
			name: "闽",
		},
		{
			CODE1: "",
			CODE: "16",
			id: 2000225,
			name: "赣",
		},
		{
			CODE1: "",
			CODE: "17",
			id: 2000226,
			name: "豫",
		},
		{
			CODE1: "",
			CODE: "18",
			id: 2000227,
			name: "湘",
		},
		{
			CODE1: "",
			CODE: "19",
			id: 2000228,
			name: "鄂",
		},
		{
			CODE1: "",
			CODE: "20",
			id: 2000229,
			name: "粤",
		},
		{
			CODE1: "",
			CODE: "21",
			id: 2000230,
			name: "桂",
		},
		{
			CODE1: "",
			CODE: "22",
			id: 2000231,
			name: "琼",
		},
		{
			CODE1: "",
			CODE: "23",
			id: 2000232,
			name: "川",
		},
		{
			CODE1: "",
			CODE: "24",
			id: 2000233,
			name: "贵",
		},
		{
			CODE1: "",
			CODE: "25",
			id: 2000234,
			name: "云",
		},
		{
			CODE1: "",
			CODE: "26",
			id: 2000235,
			name: "藏",
		},
		{
			CODE1: "",
			CODE: "27",
			id: 2000236,
			name: "陕",
		},
		{
			CODE1: "",
			CODE: "28",
			id: 2000237,
			name: "甘",
		},
		{
			CODE1: "",
			CODE: "29",
			id: 2000238,
			name: "青",
		},
		{
			CODE1: "",
			CODE: "30",
			id: 2000239,
			name: "宁",
		},
		{
			CODE1: "",
			CODE: "31",
			id: 2000240,
			name: "新",
		},
		{
			CODE1: "",
			CODE: "32",
			id: 2000241,
			name: "港",
		},
		{
			CODE1: "",
			CODE: "33",
			id: 2000242,
			name: "澳",
		},
		{
			CODE1: "",
			CODE: "34",
			id: 2000243,
			name: "台",
		},
	],
	typeOneLists: [
		{
			id: 1,
			name: "追尾碰撞"
		},
		{
			id: 2,
			name: "正面碰撞"
		},
		{
			id: 3,
			name: "侧面碰撞(同向)"
		},
		{
			id: 4,
			name: "侧面碰撞(对向)"
		},
		{
			id: 5,
			name: "侧面碰撞(直角)"
		},
		{
			id: 6,
			name: "侧面碰撞(角度不确定)"
		},
		{
			id: 7,
			name: "同向刮擦"
		},
		{
			id: 8,
			name: "对向刮擦"
		},
		{
			id: 9,
			name: "其他角度碰撞"
		},
	],
	typeTwoLists: [
		{
			id: 11,
			name: "中央隔离设施"
		},
		{
			id: 12,
			name: "同向护栏"
		},
		{
			id: 13,
			name: "对向护栏"
		},
		{
			id: 14,
			name: "交通标识支撑物"
		},
		{
			id: 15,
			name: "缓冲物"
		},
		{
			id: 16,
			name: "直立的杆或路灯柱"
		},
		{
			id: 17,
			name: "树木"
		},
		{
			id: 18,
			name: "桥墩"
		},
		{
			id: 19,
			name: "隧道口挡墙"
		},
		{
			id: 20,
			name: "建筑物"
		},
		{
			id: 21,
			name: "山体"
		},
		{
			id: 29,
			name: "其他"
		},
		{
			id: 31,
			name: "动物"
		},
		{
			id: 32,
			name: "作业/维修设备"
		},
		// {
		//   id: 39,
		//   name: "其他"
		// },
	],
	politicalLists: [
		{
			id: 1,
			name: "中共党员"
		},
		// {
		// 	id: 2,
		// 	name: "中共预备党员"
		// },
		{
			id: 3,
			name: "共青团员"
		},
		{
			id: 4,
			name: "民革党员"
		},
		{
			id: 5,
			name: "民盟盟员"
		},
		// {
		// 	id: 6,
		// 	name: "民建会员"
		// },
		// {
		// 	id: 7,
		// 	name: "民进会员"
		// },
		// {
		// 	id: 8,
		// 	name: "农工党党员"
		// },
		// {
		// 	id: 9,
		// 	name: "致公党党员"
		// },
		// {
		// 	id: 10,
		// 	name: "九三学社社员"
		// },
		// {
		// 	id: 11,
		// 	name: "台盟盟员"
		// },
		{
			id: 12,
			name: "无党派人士"
		},
		{
			id: 13,
			name: "群众"
		},
	],
	knowledgeLists: [
		{
			id: 1,
			name: "博士"
		},
		{
			id: 2,
			name: "研究生"
		},
		{
			id: 3,
			name: "大学本科"
		},
		{
			id: 4,
			name: "大专"
		},
		{
			id: 5,
			name: "中专"
		},
		{
			id: 6,
			name: "高中"
		},
		{
			id: 7,
			name: "初中"
		},
		{
			id: 8,
			name: "小学"
		},
	],
}

export default tempList;



// WEBPACK FOOTER //
// ./src/views/weifa/json/index.js